import React from 'react';
import './CompanyFormFields.css';

const CompanyFormFields = ({ formData, handleInputChange, message, messageType }) => {
  const roleOptions = [
    { value: 'Pessoas', label: 'Pessoas' },
    { value: 'Administrativo', label: 'Administrativo' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Diretoria', label: 'Diretoria' },
    { value: 'Tecnologia', label: 'Tecnologia' },
    { value: 'Operação', label: 'Operação' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Jurídico', label: 'Jurídico' }
  ];

  return (
    <div className="company-form-fields">
      {message && (
        <div className={`message ${messageType}`}>
          {message}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="companyName">Nome da Empresa *</label>
        <input
          type="text"
          id="companyName"
          name="companyName"
          value={formData.companyName}
          onChange={handleInputChange}
          placeholder="Digite o nome da empresa"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="name">Nome Completo *</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Digite seu nome completo"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">E-mail *</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="seu@email.com"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Telefone *</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          placeholder="(XX) XXXXX-XXXX"
          inputMode="numeric"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="role">Seu Departamento *</label>
        <select
          id="role"
          name="role"
          value={formData.role}
          onChange={handleInputChange}
          required
          className={`company-select ${formData.role ? 'has-value' : ''}`}
        >
          <option value="">Selecione o departamento onde você trabalha</option>
          {roleOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CompanyFormFields;

